<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">

  <el-button type="success" size="mini" @click="openModel(false)">{{$t('searchText.알본생성')}}</el-button>
  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       :row-class-name="tableRowClassName"
        :highlight-current-row="true"
       :empty-text="$t('tableText.데이타가없습니다')" >


          <el-table-column
          label="ID"
          type="index"
          align="center"
          width="50">
        </el-table-column>
        
      <el-table-column
        :label="$t('nav.아이디')" prop="mem_id" align="center">
          <template slot-scope="scope">
            
             <span @click="openIdModel(scope.row.mem_id)" class="text-primary" style="cursor:pointer">{{scope.row.mem_id}}</span>
          </template>
      </el-table-column> 



     

      <el-table-column
         :label="$t('newAdd.API밴드사')" prop="api_type" align="center">
          <template slot-scope="scope">
            
             {{scope.row.api_type}}
          </template>
      </el-table-column> 

     
     
       <el-table-column
        :label="$t('nav.도메인')" prop="domain" align="center">
          <template slot-scope="scope">
            
             {{scope.row.domain}}
          </template>
      </el-table-column> 

        <el-table-column
        :label="$t('msg.파트너')" prop="ptpage" align="center" width="300">
          <template slot-scope="scope">
             <el-input
            type="textarea"
            :rows="2"
            v-model="scope.row.ptpage">
          </el-input>
           
          </template>
      </el-table-column> 

       


        <el-table-column
        :label="$t('tableText.보유알')" prop="mem_cash" align="center">
        <template slot-scope="scope">

              {{formatMoney(scope.row.mem_cash)}}
          </template>
      </el-table-column> 

      


    
   
       <el-table-column
        :label="$t('tableText.상태')" align="center" prop="status">
         <template slot-scope="scope">
           {{statusObj[scope.row.status]}}
          </template>
      </el-table-column>

       <el-table-column
        :label="$t('tableText.메모')" prop="admin_memo" align="center" width="300">
          <template slot-scope="scope">
             <el-input
            type="textarea"
            :rows="2"
            v-model="scope.row.admin_memo">
          </el-input>
           
          </template>
      </el-table-column> 


      <el-table-column
        :label="$t('tableText.수정')" align="center">
         <template slot-scope="scope">
             <el-button type="primary" icon="el-icon-edit"  @click="openModel(scope)" size="mini"></el-button>
          </template>
      </el-table-column>
      </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
         <el-dialog
          :title="this.editIndex===-1 ? $t('tableText.추가') :$t('tableText.수정')"
          :visible.sync="creatModel" :width="layoutWidth1" :close-on-click-modal ="false">

          <el-form ref="form" :model="form" label-width="130px" v-loading="loading" :rules="rules">
           
             <table class="table table-bordered myTable">
               <tr>
                  <td width="50%">
                      <el-form-item :label="$t('newAdd.사이트이름')"  class="mb-0 formItem">
                        <el-input v-model="form.sitename" ></el-input>
                    </el-form-item>
                  </td>
                  <td>
                     <el-form-item :label="$t('newAdd.API주소')"  class="mb-0 formItem">
                        <el-input v-model="form.api_url" ></el-input>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td width="50%">
                      <el-form-item :label="$t('nav.아이디')" prop="mem_id" class="mb-0 formItem">
                        <el-input v-model="form.mem_id" :disabled ="disfalse"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('nav.비밀번호')" :prop="editIndex===-1 ? 'mem_pw' :'empty'" class="mb-0 formItem">
                      <el-input v-model="form.mem_pw"></el-input>
                    </el-form-item>
                  </td>
                </tr>


                 

                
                 <tr>
                  <td width="50%">
                      <el-form-item label="sd_id" prop="sd_id" class="mb-0 formItem">
                        <el-input v-model="form.sd_id" ></el-input>
                    </el-form-item>
                  </td>
                  <td>
                     <el-form-item label="sd_key" prop="sd_key" class="mb-0 formItem">
                        <el-input v-model="form.sd_key" ></el-input>
                    </el-form-item>
                  </td>
                </tr>

                <tr>
                  <td width="50%">
                      <el-form-item label="sd_name" prop="sd_name" class="mb-0 formItem">
                        <el-input v-model="form.sd_name" ></el-input>
                    </el-form-item>
                  </td>
                  <td>
                     <el-form-item label="sd_pwd" prop="sd_pwd" class="mb-0 formItem">
                        <el-input v-model="form.sd_pwd" ></el-input>
                    </el-form-item>
                  </td>
                </tr>

                <tr>
                  <td>
                    <el-form-item :label="$t('tableText.연락처')" prop="mem_hp" class="mb-0 formItem">
                      <el-input v-model="form.mem_hp"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('tableText.계좌번호')" class="mb-0 formItem">
                      <el-input v-model="form.mem_banknum"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                
                
               
           
                
                 <tr>
                <td>
                    <el-form-item :label="$t('tableText.회도메인')" class="mb-0 formItem">
                      <el-input type="textarea" :rows="1" v-model="form.domain"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                     <el-form-item label="hn_key" class="mb-0 formItem">
                      <el-input v-model="form.hn_key"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                  <tr>
                <td>
                   <el-form-item label="hn_id" class="mb-0 formItem">
                      <el-input v-model="form.hn_id"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                     <el-form-item label="hn_pwd" class="mb-0 formItem">
                      <el-input v-model="form.hn_pwd"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                 <tr>
                 
                  <td>
                     <el-form-item :label="$t('tableText.파도메인')" class="mb-0 formItem">
                      <el-input v-model="form.ptpage" type="textarea" :rows="1"></el-input>
                    </el-form-item>
                  </td>
                   <td>
                    <el-form-item label="sp_key" class="mb-0 formItem">
                      <el-input v-model="form.sp_key"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                  <tr>
                 
                  <td>
                      <el-form-item label="sp_name" class="mb-0 formItem">
                      <el-input v-model="form.sp_name"></el-input>
                    </el-form-item>
                  </td>
                   <td>
                      <el-form-item label="sp_pwd" class="mb-0 formItem">
                      <el-input v-model="form.sp_pwd"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                 
                  <td>
                      <el-form-item class="mb-0 formItem2">
                        <div class="d-flex align-items-center" style="margin-top:3px">
                      <span style="margin-left: -125px;">rs_id</span><el-input v-model="form.rs_id" class="w-50 ml-1 mr-1"></el-input> rs_key<el-input v-model="form.rs_key" class="w-50 ml-1"></el-input>
                    </div>
                    </el-form-item>
                  </td>
                   <td>
                      <el-form-item label="rs_token" class="mb-0 formItem">
                      <el-input v-model="form.rs_token"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  
                  <td>
                    <el-form-item label="밴드사" class="mb-0 formItem">
                     <el-select v-model="form.api_type" size="mini" style="width: 100px;" filterable>
               <el-option
                      v-for="item in apitypes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
                              </el-form-item>
                  </td>
                    <td>
                      <el-form-item :label="$t('msg.파워볼')" class="mb-0 formItem">
                        <el-select v-model="form.power" size="mini" style="width: 100px;" filterable>
               <el-option
                      v-for="item in powertypes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                 
                  <td>
                    <el-form-item :label="$t('newAdd.루징')" class="mb-0 formItem">
                     <el-select v-model="form.rosing" size="mini" style="width: 100px;" filterable>
               <el-option
                      v-for="item in rosingtypes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
                              </el-form-item>
                  </td>
                   <td >
                   <el-form-item :label="$t('newAdd.지값방식')" class="mb-0 formItem">
                     <el-select v-model="form.money_type" size="mini" style="width: 100px;" filterable>
                         <el-option
                                v-for="item in moneytypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                        </el-select>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                   <td colspan="2">
                    <el-form-item label="" class="mb-0 formItem labelNone2">
                      <el-input type="textarea" :rows="1" v-model="form.admin_memo"></el-input>
                    </el-form-item>
                  </td>
                </tr>
               
               
</table>
          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="creatModel = false">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="submit" :disabled="disabled">{{$t('msg.확인')}}</el-button>
          </span>
        
       
       
        </el-dialog>
      
     
         <el-dialog 
          :visible.sync="bonModel"
          :width="dWidth" :close-on-click-modal ="false">

          <el-form ref="form" :model="bonForm" label-width="100px" v-loading="layLoading">
            
            <el-form-item :label="$t('nav.아이디')" class="mb-0">
              <el-input v-model="bonForm.mem_id"  class="w-75"></el-input>
            </el-form-item>
          
            <el-form-item :label="$t('tableText.타입')" class="mb-0 ">
              <el-select placeholder="선택" v-model="io_type" class="w-75 typeIco">
                  <el-option
                  v-for="item in ioType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('tableText.금액')" class="mb-0">
              <el-input v-model="bonForm.money" type="number"  class="w-75"></el-input>
            </el-form-item>

             <el-form-item :label="$t('tableText.메모')" class="mb-0">
              <el-input v-model="bonForm.memo" type="text"  class="w-75"></el-input>
            </el-form-item>
          <el-form-item label="" class="mb-0" style="margin-left:-100px">
             <el-button type="primary" size="mini" plain style="margin-left:3px;padding:7px 8px" @click="getVal('10000')">1{{$t('tableText.만원')}}</el-button>
             <el-button type="primary" size="mini" plain style="margin-left:3px;padding:7px 8px" @click="getVal(50000)">5{{$t('tableText.만원')}}</el-button>
             <el-button type="primary" size="mini" plain style="margin-left:3px;padding:7px 8px" @click="getVal(100000)">10{{$t('tableText.만원')}}</el-button>
             <el-button type="primary" size="mini" plain style="margin-left:3px;padding:7px 8px" @click="getVal(500000)">50{{$t('tableText.만원')}}</el-button>
             <el-button type="primary" size="mini" plain style="margin-left:3px;padding:7px 8px" @click="getVal(1000000)">100{{$t('tableText.만원')}}</el-button>
             <el-button type="primary" size="mini" plain style="margin-left:3px;padding:7px 8px" @click="getVal(0)">{{$t('tableText.정정')}}</el-button>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="bonModel = false">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="bonSumbit">{{$t('msg.확인')}}</el-button>
          </span>
        
       
       
        </el-dialog>  
         
				
</div>
 </template>

 <script>
 import layer from '../../components/common/layer.vue';
 import bubonDialog from '../../components/common/bubon-dialog.vue';
 
 var punycode = require('punycode');
 
    export default {
    components: {
      bubonDialog,
      layer
    },
    	data(){
    		return{

             apitypes:[{
              label:this.$i18n.t("newAdd.슬롯다이아"),
              value:'sd'
            },
             {
              label:this.$i18n.t("newAdd.슬롯게이트"),
              value:'sg'
            },
              {
              label:this.$i18n.t("newAdd.스페이더"),
              value:'sp'
            }, {
              label:this.$i18n.t("newAdd.아너링크"),
              value:'hn'
            }
            
            ],
          
             powertypes:[{
              label:this.$i18n.t("msg.적용"),
              value:'1'
            },
             {
              label:this.$i18n.t("msg.없음"),
              value:'0'
            },
              
            
            ],
          rosingtypes:[{
              label:this.$i18n.t("msg.적용"),
              value:'1'
            },
             {
              label:this.$i18n.t("msg.없음"),
              value:'0'
            },
              
            
            ],
          moneytypes:[{
              label:this.$i18n.t("newAdd.심리스"),
              value:'sim'
            },
             {
              label:this.$i18n.t("newAdd.트랜스퍼"),
              value:'trans'
            },
              
            
            ],
          layoutWidth1:'600px',
          bonModel:false,
           dWidth:'400px',
          io_type:'',
           ioType: [
               {
                label: this.$i18n.t("msg.충전"),
                 value: '1',
               
              }, {
                label: this.$i18n.t("msg.환전"),
                 value: '2',
               
              }],
               level_title:{
              '-2':this.$i18n.t("msg.블랙"),
              '-1':this.$i18n.t("msg.대기"),
              '0':this.$i18n.t("msg.기본")             
            },
            
          
             bonForm:{
            mem_id:'',
            money:'',
            memo:'',
          },
          domain:window.sessionStorage.getItem('domain'),
          sitetype:window.sessionStorage.getItem('sitetype'),
          bg:window.sessionStorage.getItem('bg'),
          data:[],
          pcode:punycode,
          disfalse:false,
          distrue:true,
          layLoading:false,
          disabled:false,
          formLoading:false,
          idDialogVisible: false,
          tableLoading:false,
          dialogVisible: false,
          dialogTitle: this.$i18n.t("title.소속회원"), // 标题
          statusObj:{
            '1':this.$i18n.t("msg.정상"),
            '0':this.$i18n.t("msg.차단")
          },
          editIndex:-1,
          creatModel:false,
          statusOptions:[
             {
              label:this.$i18n.t("msg.정상"),
              value:'1'
            },
             {
              label:this.$i18n.t("msg.차단"),
              value:'0'
            },
            {
              label:this.$i18n.t("status.선택"),
              value:''
            },

            ],
         
            bubonlist:[{
                label:this.$i18n.t("status.선택"),
              value:''
            }
            
            ],
    		  form:{
            money_type:'',
            hn_pwd:'',
            hn_id:'',
            hn_key:'',
            admin_memo:'',
            api_type:'sg',
            sd_name:'',
            sd_pwd:'',
            sd_id:'',
            sd_key:'',
            domain:'',
            ptpage:'',
            agent_name:'',
            rosing:'',
            power:'',
             boss:'',
             apikey:'',
             apiname:'',
             apipwd:'',
             api_url:'',
             sitename:'',
             opcode:'',
             apiname:'',
            reg_code:'',
            mem_pw:'',
            mem_name:'',
            mem_id:'',
             id:'',
            event_loing_recom:'0',
            event_loing_recom_s:'0',
            event_loing_group_recom:'0',
            event_loing_group_recom_s:'0',

            event_loing_recom1:'0',
            event_loing_recom_s1:'0',
            event_loing_group_recom1:'0',
            event_loing_group_recom_s1:'0',


             event_loing_recom_e:'',
            event_loing_recom_slot:'',
              mem_banknum:'',
            mem_bankcode:'',
            mem_bankname:'',
            mem_jumin:'',
            mem_hp:'',
            sp_key:'',
            sp_name:'',
            sp_pwd:'',
            status:'',
            rs_key:'',
            rs_id:'',
            rs_token:'',
          },
          optvalue:[
           {
              label:'1',
              value:'1'
            },
             {
              label:'2',
              value:'2'
            },
             {
              label:'3',
              value:'3'
            },


          ],
          valuenum:'1',
    	
		    		 total:0,
		    		 size:0,
		    		 loading: false,
		    		 tableData: [],
			       currentPage:1,
			       rules: {
                  mem_jumin:[{ required: true, message: '', trigger: 'blur'}],
                  mem_bankname:[{ required: true, message: '', trigger: 'blur'}],

                  //apiname:[{ required: true, message: '', trigger: 'blur'}],
                  //apipwd:[{ required: true, message: '', trigger: 'blur'}],


                  //opcode:[{ required: true, message: '', trigger: 'blur'}],
                  //apikey:[{ required: true, message: '', trigger: 'blur'}],
                  mem_id:[{ required: true, message: '', trigger: 'blur'}],
                  mem_name:[{ required: true, message: '', trigger: 'blur'}],
                  mem_pw:[{ required: true, message: '', trigger: 'blur'}],
                 
                },
              
			         
			 
    			}
    			
    			
    		},
    		created() {
    			
          //console.log(punycode);
    			this.getList();
    			
			
		},
   
    	methods:{
        bonOpen(e,s){

          this.bonModel = true
          if(e == 1){
         
            this.io_type = '1'
          }if(e == 2){
           
            this.io_type = '2'
          }

          //console.log(s)

          this.bonForm.mem_id = s.row.mem_id

        },
         bonSumbit(){
          let token=window.sessionStorage.getItem('user');
           this.layLoading = true
              this.$axios({
                    method:'post',
                    url:this.domain+'/admin/admin_cash_up',
                    data:{
                      mem_id:this.bonForm.mem_id,
                      money:this.bonForm.money,
                      memo:this.bonForm.memo,
                      io_type:this.io_type
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
      
              }).then((response) =>{ 
                   
                
                     this.layLoading = false
                    let item = response.data.data
                  //  console.log('data==',item)
                    if(response.data.code==200){
            

                     this.bonForm.mem_id=''
                     this.bonForm.money=''
                     this.bonForm.memo=''
                       this.bonModel = false
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      }) 
                      this.getList();  
                    }else
                    {
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    
                     
                
                 
              }).catch((error) =>{
                 this.$message({
                          message:'error',
                          type:'error'
                      })   

                    this.layLoading = false
              })
        },
      cutout(cellValue) {

           //cellValue=punycode.toUnicode(cellValue)
           return cellValue.replace(/\,/g, '</br>')
          },
         // 关闭弹框（头部的X）
        
        handleClose1 () {
               this.idDialogVisible = false
            },
        cancelData1(){
          this.idDialogVisible = false
        },
         openIdModel(id){
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['830px', '680px'],
        });
        
        },
        // 关闭弹框（头部的X）
            handleClose () {
               this.dialogVisible = false
            },
        cancelData(){
          this.dialogVisible = false
        },
       
        tableRowClassName({row, rowIndex}) {
     
       if (rowIndex%2 === 1) {
        return 'odd-row';
       }
       else{
         return 'edd-row';
       }
    },
        openModel(e = false){
          let token=window.sessionStorage.getItem('user');


         

          if(!e){

            console.log('add');


            this.form = {
              money_type:'',
                 hn_pwd:'',
                 hn_id:'',
                 hn_key:'',
                  power:'',
                  rosing:'',
                  admin_memo:'',
                  ptpage:'',
                  domain:'',
                  mem_pw:'',
                  mem_name:'',
                  mem_id:'',
                  apiname:'',
                  apipwd:'',
                  apikey:'',
                   sitename:'',
                  api_url:'',
                  opcode:'',
                  apiname:'',
                  sp_key:'',
                  sp_name:'',
                  sp_pwd:'',
                  id:'',
                  sd_id:'',
                  sd_key:'',
                  rs_id:'',
                  rs_key:'',
                  sd_name:'',
                  sd_pwd:'',
                  api_type:'sg',
                  mem_banknum:'',
                  mem_bankcode:'',
                  mem_bankname:'',
                  mem_jumin:'',
                  mem_hp:'',
                  rs_token:'',
                  status:'1'
                  

                 }




           

            //这里调用select接口

             this.disfalse = false
             this.editIndex = -1

          }
          else{
            //修改
            this.loading = true
            this.$axios({
                  method:'get',
                  url:this.domain+'/admin/admin?id='+e.row.id,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
                  this.loading = false
                  let item = response.data.data
                  console.log('data==',item)
                  
                    this.form = {
                      rs_id:item.rs_id,
                  rs_key:item.rs_key,
                   rs_token:item.rs_token,
                        sd_id:item.sd_id,
                        power:item.power,
                        money_type:item.money_type,
                        rosing:item.rosing,
                  sd_key:item.sd_key,
                  sd_name:item.sd_name,
                  sd_pwd:item.sd_pwd,
                  sp_key:item.sp_key,
                  sp_name:item.sp_name,
                  sp_pwd:item.sp_pwd,
                  api_type:item.api_type,
                   admin_memo:item.admin_memo,
                          mem_pw:item.mem_pw,
                          mem_name:item.mem_name,
                          id:item.id,
                          mem_id:item.mem_id,
                          apiname:item.apiname,
                          apipwd:item.apipwd,
                          opcode:item.opcode,
                           api_url:item.api_url,
                            sitename:item.sitename,
                          apikey:item.apikey,
                          mem_banknum:item.mem_banknum,
                          mem_bankcode:item.mem_bankcode,
                          mem_bankname:item.mem_bankname,
                          mem_jumin:item.mem_jumin,
                          mem_hp:item.mem_hp,
                          domain:item.domain,
                          ptpage:item.ptpage,
                          status:item.status,
                          hn_id:item.hn_id,
                          hn_key:item.hn_key,
                          hn_pwd:item.hn_pwd,

                }
                this.editIndex = e.$index
                 this.disfalse = true
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })
          }
          this.creatModel = true
        },
         
    		 submit(){
             
              let token=window.sessionStorage.getItem('user');
              this.$refs.form.validate((e)=>{
             if(!e) return;
           
             //添加提交
              if (this.editIndex === -1) {
                 this.disabled = true
                 this.loading =true
               this.$axios({
                        method:'post',
                        url:this.domain+'/admin/admin_insert',
                        data:{
                        
                          domain:this.form.domain,
                          ptpage:this.form.ptpage,
                          power:this.form.power,
                          rosing:this.form.rosing,
                          mem_pw:this.form.mem_pw,
                          mem_name:this.form.mem_name,
                          id:this.form.id,
                           money_type:this.form.money_type,
                          admin_memo:this.form.admin_memo,
                          mem_id:this.form.mem_id,
                          opcode:this.form.opcode,
                          apikey:this.form.apikey,
                          api_url:this.form.api_url,
                          sitename:this.form.sitename,
                          apiname:this.form.apiname,
                          apipwd:this.form.apipwd,
                          mem_banknum:this.form.mem_banknum,
                          mem_bankcode:this.form.mem_bankcode,
                          mem_bankname:this.form.mem_bankname,
                          mem_jumin:this.form.mem_jumin,
                          mem_hp:this.form.mem_hp,
                          sd_id:this.form.sd_id,
                          sd_key:this.form.sd_key,
                          sd_pwd:this.form.sd_pwd,
                          sd_name:this.form.sd_name,
                          api_type:this.form.api_type,
                          sp_key:this.form.sp_key,
                          sp_pwd:this.form.sp_pwd,
                          sp_name:this.form.sp_name,
                          hn_id:this.form.hn_id,
                          hn_key:this.form.hn_key,
                          rs_id:this.form.rs_id,
                          rs_key:this.form.rs_key,
                          rs_token:this.form.rs_token,
                          hn_pwd:this.form.hn_pwd,
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                            message:response.data.msg,
                            type: 'warning'
                          });


                                
                            }else{
                               this.$message({
                            message:response.data.msg,
                            type: 'success'
                          });
                               //console.log(this.form);
                               this.getList();
                               //this.tableData.unshift(this.form)
                               //关闭
                              
                              this.creatModel = false

                            }
                           this.loading =false
                           this.disabled = false
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
              
            }else{
              
              this.$axios({
                      method:'post',
                      url:this.domain+'/admin/admin_up',
                      data:{
                         rs_id:this.form.rs_id,
                          rs_key:this.form.rs_key,
                          sd_id:this.form.sd_id,
                          sd_key:this.form.sd_key,
                           admin_memo:this.form.admin_memo,
                          power:this.form.power,
                          rosing:this.form.rosing,
                          sd_pwd:this.form.sd_pwd,
                          sd_name:this.form.sd_name,
                          api_type:this.form.api_type,
                          mem_pw:this.form.mem_pw,
                          domain:this.form.domain,
                          ptpage:this.form.ptpage,
                          mem_name:this.form.mem_name,
                          id:this.form.id,
                          mem_id:this.form.mem_id,
                          opcode:this.form.opcode,
                          apikey:this.form.apikey,
                           api_url:this.form.api_url,
                            sitename:this.form.sitename,
                           apiname:this.form.apiname,
                          apipwd:this.form.apipwd,
                          mem_banknum:this.form.mem_banknum,
                          mem_bankcode:this.form.mem_bankcode,
                          mem_bankname:this.form.mem_bankname,
                          mem_jumin:this.form.mem_jumin,
                          mem_hp:this.form.mem_hp,
                          sp_key:this.form.sp_key,
                          rs_token:this.form.rs_token,
                          sp_pwd:this.form.sp_pwd,
                          sp_name:this.form.sp_name,
                          status:this.form.status,
                          hn_id:this.form.hn_id,
                          hn_key:this.form.hn_key,
                          hn_pwd:this.form.hn_pwd,
                           money_type:this.form.money_type,
                         
                        },   
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                   if(response.data.code==200){
                       this.creatModel = false
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })
                      this.getList()  
                      this.disabled = false
                    }else
                    {
                       //this.creatModel = false
                       this.$message({
                          message:response.data.msg,
                          type:'warning'
                      })
                    }
                    
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })

            }
            })
              
            
        },
			
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			    
       
    		getList(){

    		
              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/adminlist?page='+this.currentPage;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                   //  console.log('tableData=',response.data.data)
                     let data = response.data
                     this.tableData =data.data
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =data.per_page
                     
                     this.loading =false
               
            }).catch((error) =>{
            	
               this.$message.error(error);
              this.loading = false
               
            })
    		},
    	
    		 getVal(e){

          if(this.bonForm.money=='')
          {
this.bonForm.money='0';
          }

          if(e=='0')
          {
            this.bonForm.money='0';
          }

          this.bonForm.money=parseInt(this.bonForm.money)+parseInt(e)
          console.log(e)
        },
    	}
  }
</script>

 <style scoped>

/deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }
 /deep/.typeIco .el-input__icon{
  line-height: 30px;
 }
 >>> .el-table__body tr.current-row > td {
    background-color: #d3d3d3!important;
  }
</style>


// WEBPACK FOOTER //
// src/views/admin/list.vue